import { FichaRegistro } from "app/models/fichaRegistro.model"

 export interface TipologiaUbicación {
    tipologiaId: number
    descripcion: string
    valor1: string
    valor2: string
    valor3: string
  }

  
export class InfoUbicacion {
  direccion: string
  departamento: TipologiaUbicación
  municipio: TipologiaUbicación
  latitud: string
  longitud: string
  aldea: string
  elevacion: string
  utm: string
  gtm: string
  catastro: string
  finca: string
  folio: string
  libro: string
  mapa:string
  geodesica:string

  constructor(ficha: FichaRegistro) {
    this.direccion = ficha.direccion
    this.departamento = ficha.departamento
    this.municipio = ficha.municipio
    this.latitud = ficha.latitud
    this.longitud = ficha.longitud
    this.aldea = ficha.aldea
    this.elevacion = ficha.elevacion
    this.utm = ficha.coordenadasUtm
    this.gtm = ficha.coordenadasGtm
    this.catastro = ficha.catastro
    this.finca = ficha.fincaNo
    this.folio = ficha.folioNo
    this.libro = ficha.libroNo
    this.mapa= ficha.mapa
    this.geodesica= ficha.geodesica
  }
}

